export const INGREDIENTS = [
  {
    image: require('../../../../asset/images/detail/bleu/bleu_point_img01.png'),
    title: 'ROSA DAMASCENA FLOWER WATER',
    desc: '11가지 히알루론산 콤플렉스인 장미꽃수가 피부의 보습에 도움을 주며 피부를 보다 부드럽게 해줍니다.',
  },
  {
    image: require('../../../../asset/images/detail/bleu/bleu_point_img02.png'),
    title: 'SHEA BUTTER',
    desc: '자연에서 온 시어버터는 보습제 역할을 해주고 수분막을 형성시켜줍니다.',
  },
  {
    image: require('../../../../asset/images/detail/bleu/bleu_point_img03.png'),
    title: 'SWEET ALMOND OIL',
    desc: '스위트 아몬드 오일은 고보습의 효과를 지닌 동시에 피부 자극이 적어 부드럽게 케어가 가능합니다.',
  },
  {
    image: require('../../../../asset/images/detail/bleu/bleu_point_img04.png'),
    title: 'EGGPLANT FRUIT EXTRACT',
    desc: '문제성 피부 트러블을 케어하여 피부 보호에 도움을 줄 수 있습니다.',
  },
  {
    image: require('../../../../asset/images/detail/bleu/bleu_point_img05.png'),
    title: 'JOJOBA SEED OIL',
    desc: '피부 자극이 적은 자연에서 온 호호바씨 오일은 피부를 진정시키는데 도움을 주고 피부를 보다 부드럽게 해줍니다.',
  },
  {
    image: require('../../../../asset/images/detail/bleu/bleu_point_img06.png'),
    title: 'OCIMUM SANCTUM LEAF EXTRACT',
    desc: '홀리바질잎 추출물은 비타민C, 비타민E 등의 성분이 함유 되어 있어 피부를 보호해줍니다.',
  },
  {
    image: require('../../../../asset/images/detail/bleu/bleu_point_img07.png'),
    title: 'CORALLINA OFFICINALIS EXTRACT',
    desc: '참산호말 추출물은 미네랄, 칼슘, 마그네슘 등을 함유하고 있어 피부를 진정시켜줍니다.',
  },
  {
    image: require('../../../../asset/images/detail/bleu/bleu_point_img08.png'),
    title: 'TURMERIC ROOT EXTRACT',
    desc: '울금뿌리 추출물은 피부를 보호하고 진정시키는데 탁월합니다.',
  },
];
